<template>
  <a
    :title=" formType === 'login' ? 'Login with LinkedIn' : 'Sign up with LinkedIn'"
    v-on="formType === 'login' ? { click: linkedinLogin } : { click: socialSignUp }"
  >
    <LinkedinIcon />
    <span>
      LinkedIn
    </span>
  </a>
</template>
<script>
import LinkedinIcon from '../../assets/svg/icon-colored-linkedin-fill.svg?vue-component';

export default {
  components: { LinkedinIcon },
  props: {
    keepMeLoggedIn: Boolean,
    errored: Boolean,
    campaign: Boolean,
    termsAgreed: Boolean,
    formType: { type: String, default: '' },
  },
  methods: {
    async linkedinLogin() {
      await this.$root.$emit('check');
      const routePath = this.$route.path.replace(/^\/|\/$/g, '');
      const queryParams = Object.entries(this.$route.query).map((i) => (i[1] ? `${i[0]}=${i[1]}` : '')).join(',');
      if (this.formType === 'signup' && !this.errored && process.client) {
        window.location = `https://www.linkedin.com/oauth/v2/authorization?response_type=code&scope=${encodeURI('r_liteprofile r_emailaddress')}&client_id=${this.$config.linkedinApiKey}&redirect_uri=${encodeURI(`${this.$config.siteUrl}/${routePath}`)}&state=${queryParams}`;
      } else if (this.formType === 'login') {
        window.location = `https://www.linkedin.com/oauth/v2/authorization?response_type=code&scope=${encodeURI('r_liteprofile r_emailaddress')}&client_id=${this.$config.linkedinApiKey}&redirect_uri=${encodeURI(`${this.$config.siteUrl}/${routePath}`)}&state=${queryParams}`;
      }
    },
    checkTerms() {
      this.$root.$emit('check-terms', true);
    },
    socialSignUp() {
      if (this.termsAgreed) {
        this.linkedinLogin();
      }
      this.checkTerms();
    },
  },
};
</script>

<style lang="scss" scoped>
a {
  border-radius: 0;
  text-align: center;
  transition: none;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 100%;
  color: var(--main-light);
  padding: var(--spacing-14);

  svg {
    vertical-align: sub;
    margin-right: var(--spacing-16);
  }
}

@include bp($bp-mobile) {
  a {
    svg {
      margin-right: -2px;
    }

    span {
      display: none;
    }
  }
}
</style>
